/* eslint-disable react/no-unescaped-entities */
import { Link, mergeStyles, Modal, PrimaryButton, Stack, Text, useTheme } from '@fluentui/react';
import React, { useEffect } from 'react';
import { InlineConsent, RemoteMessage } from '../../components';
import { SpinnerLoader } from '../../components/Invoker/Loader';
import { GLOBALS, ReminderData } from '../../globals';
import { patientAuthorizationJSX } from './Zoryve.common';
import { checkExistingAccount, createEnrollment } from './ZoryveDirect.services';

export const ZoryvePatientConsent = (): JSX.Element => {
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;

  return (
    <>
      <Text style={{ cursor: 'pointer' }} onClick={() => setIsModalOpen(true)}>
        <u>PATIENT AUTHORIZATION</u>
      </Text>
      <Modal
        isOpen={isModalOpen}
        allowTouchBodyScroll={true}
        isBlocking={false}
        onDismiss={() => setIsModalOpen(false)}
        styles={{
          main: { borderRadius: theme.effects.roundedCorner6, minHeight: 0 },
        }}
      >
        <div
          className={mergeStyles({
            padding: '1rem',
            boxShadow: theme.effects.elevation8,
            width: width,
            borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
            background: theme.palette.neutralPrimary,
          })}
        >
          <Stack
            style={{
              height: '100%',
              color: 'black',
            }}
          >
            <h3>PATIENT AUTHORIZATION</h3>
            {patientAuthorizationJSX}
          </Stack>
        </div>
      </Modal>
    </>
  );
};

export const ZoryvePatientTerms = (): JSX.Element => {
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;

  return (
    <>
      <Stack style={{ width: '85%', paddingBottom: '1rem' }}>
        <Text
          style={{
            cursor: 'pointer',
            background: theme.palette.themePrimary,
            padding: '0.5rem',
            color: 'black',
            textAlign: 'center',
          }}
          onClick={() => setIsModalOpen(true)}
        >
          <u>ZORYVE Direct Savings Card Terms and Conditions</u>
        </Text>
      </Stack>
      <Modal
        isOpen={isModalOpen}
        allowTouchBodyScroll={true}
        isBlocking={false}
        onDismiss={() => setIsModalOpen(false)}
        styles={{
          main: { borderRadius: theme.effects.roundedCorner6, minHeight: 0 },
        }}
      >
        <div
          className={mergeStyles({
            padding: '1rem',
            boxShadow: theme.effects.elevation8,
            width: width,
            borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
            background: theme.palette.neutralPrimary,
          })}
        >
          <Stack
            style={{
              height: '100%',
              color: 'black',
              paddingBottom: '10rem',
            }}
          >
            <h3>ZORYVE Direct Savings Card Terms and Conditions</h3>
            <ul>
              <li>
                The ZORYVE Direct Savings Card (the “Savings Card”) is valid only for patients with
                commercial (private or non-governmental) insurance. Patients enrolled in Medicare,
                Medicaid, Medigap, TRICARE®, the Department of Veterans Affairs healthcare program,
                or any other federal or state government-funded healthcare program (“Government
                Programs”) are not eligible. Patients who become enrolled in any Government
                Program(s) during their enrollment period will become ineligible for the Savings
                Card program at that time. Uninsured, cash-paying patients are not eligible.
                Eligible patients must be residents of the United States and Puerto Rico and the
                patient or the patient’s parent or guardian must be 18 years or older to receive
                Savings Card program assistance.
              </li>
              <li>
                The Savings Card should only be used with a valid prescription for ZORYVE that is
                consistent with the ZORYVE Prescribing Information
              </li>
              <li>
                Eligible patients with commercial prescription drug insurance coverage for ZORYVE
                may pay as little as $0 per fill. Eligible patients with commercial drug insurance
                that does not cover ZORYVE may pay as little as $75 per fill. Individual patient
                savings are limited to $875 per fill and $5,000 in maximum total savings per
                calendar year, January 1 - December 31. This Savings Card program is not health
                insurance or a benefit plan. Distribution or use of the Savings Card does not
                obligate use or continuing use of any specific product or provider. The user,
                whether patient or guardian, is responsible for reporting the receipt of all Savings
                Card program savings received to any insurer, health plan, or other third party who
                pays for or reimburses any part of the prescription filled using the Savings Card
                program, as may be required.
              </li>
              <li>
                The Savings Card is not valid for supplies of ZORYVE that the patient receives for
                free or that are eligible to be reimbursed by private insurance plans or other
                healthcare or pharmaceutical assistance programs that reimburse the patient in part
                or for the entire cost of ZORYVE. Patient, guardian, pharmacist, prescriber, and any
                other person using the Savings Card agree not to seek reimbursement for all or any
                part of the savings received by the recipient through this offer. The Savings Card
                should not be used if the patient’s commercial insurance or health plan prohibits
                the use of manufacturer co-pay cards.
              </li>
              <li>
                This Savings Card is available with a valid prescription and cannot be combined with
                any other rebate/coupon, free trial, or similar offer for the specified
                prescription. Use of this Savings Card must be consistent with all relevant health
                insurance requirements and payer agreements. Participating pharmacies are obligated
                to inform third-party payers about the use of the Savings Card as provided under the
                applicable insurance or as otherwise required by contract or law. The Savings Card
                may not be sold, purchased, traded or offered for sale, purchase, or trade. The
                Savings Card is limited to one per person during the offer period and is not
                transferrable. Void where prohibited by law, taxed, or restricted.
              </li>
              <li>
                This Savings Card is available with a valid prescription and cannot be combined with
                any other rebate/coupon, free trial, or similar offer for the specified
                prescription. Use of this Savings Card must be consistent with all relevant health
                insurance requirements and payer agreements. Participating pharmacies are obligated
                to inform third-party payers about the use of the Savings Card as provided under the
                applicable insurance or as otherwise required by contract or law. The Savings Card
                may not be sold, purchased, traded or offered for sale, purchase, or trade. The
                Savings Card is limited to one per person during the offer period and is not
                transferrable. Void where prohibited by law, taxed, or restricted.
              </li>
              <li>
                The Savings Card program renews annually on January 1. Arcutis Biotherapeutics
                reserves the right to rescind, revoke, amend, or terminate the program without
                notice at any time.
              </li>
              <li>
                If you have questions, call (844) 979-1288 from 6:00 am - 5:00 pm PT, Monday -
                Friday, except holidays.
              </li>
            </ul>
          </Stack>
          <PrimaryButton
            className={mergeStyles({
              height: '3rem',
              color: 'black',
              minWidth: '8rem',
              width: '90%',
              borderRadius: theme.effects.roundedCorner6,
              boxShadow: theme.effects.elevation8,
              position: 'absolute',
              bottom: 10,
              left: 'auto',
              right: 'auto',
            })}
            onClick={() => setIsModalOpen(false)}
          >
            Accept
          </PrimaryButton>
        </div>
      </Modal>
    </>
  );
};

export const ZoryveSavingProgramTerms = (): JSX.Element => {
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;
  // const [isButtonsDisabled, setIsButtonsDisabled] = React.useState(true);
  // const modalContentRef = useRef<HTMLDivElement | null>(null);
  // const [patientAuthorizationChecked, setPatientAuthorizationChecked] = React.useState(false);

  // useEffect(() => {
  //   // Diasble body scroll when Modal open
  //   document.body.style.overflow = 'hidden';

  //   return () => {
  //     // Enable body scroll when Modal unmounts
  //     document.body.style.overflow = 'unset';
  //   };
  // }, [isModalOpen]);

  // const handleCheckboxChange = () => {
  //   setPatientAuthorizationChecked(!patientAuthorizationChecked);
  // };

  // useEffect(() => {
  //   if (patientAuthorizationChecked) setIsButtonsDisabled(false);
  //   else setIsButtonsDisabled(true);
  // }, [patientAuthorizationChecked]);

  // const handleOnSubmit = () => {
  //   setIsModalOpen(false);
  //   // onSubmit && onSubmit([input]);
  // };

  // if (!isModalOpen) {
  //   return (
  //     <Stack style={{ paddingBottom: '1rem' }}>
  //       <Stack
  //         style={{
  //           padding: '1rem',
  //           background: theme.palette.themePrimary,
  //           borderRadius: '10px',
  //           width: '85%',
  //           paddingBottom: '1rem',
  //           textAlign: 'center',
  //         }}
  //       >
  //         <a
  //           style={{
  //             cursor: 'pointer',
  //             color: 'black',
  //             textDecoration: 'underline',
  //           }}
  //           onClick={() => setIsModalOpen(true)}
  //         >
  //           ZORYVE DIRECT SAVINGS PROGRAM TERMS
  //         </a>
  //       </Stack>
  //     </Stack>
  //   );
  // }

  // return (
  //   <Modal
  //     isOpen={isModalOpen}
  //     styles={{
  //       main: {
  //         borderRadius: theme.effects.roundedCorner6,
  //         overflowY: 'scroll',
  //         display: 'flex',
  //         flexDirection: 'column',
  //       },
  //     }}
  //     allowTouchBodyScroll={true}
  //   >
  //     <div
  //       className={mergeStyles({
  //         padding: '1rem',
  //         boxShadow: theme.effects.elevation8,
  //         width: width,
  //         borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
  //         background: theme.palette.neutralPrimary,
  //       })}
  //     >
  //       <Stack
  //         style={{
  //           height: '100%',
  //           color: 'black',
  //           paddingBottom: '0rem',
  //           overflowY: 'scroll',
  //         }}
  //       >
  //         <Stack horizontal horizontalAlign="start">
  //           <h3
  //             style={{
  //               color: 'black',
  //               fontSize: '14px',
  //               margin: 0,
  //               paddingBottom: '0.5rem',
  //             }}
  //           >
  //             ZORYVE DIRECT SAVINGS PROGRAM PATIENT AUTHORIZATION
  //           </h3>
  //         </Stack>
  //         <div
  //           ref={modalContentRef}
  //           style={{
  //             maxHeight: window.innerHeight / 1.8,
  //             overflow: 'auto',
  //             paddingBottom: '1rem',
  //             fontSize: '11px',
  //             fontWeight: 400,
  //           }}
  //         >
  //           {zoryvePatientAuthorization}
  //           <Stack
  //             horizontal
  //             horizontalAlign="start"
  //             verticalAlign="center"
  //             style={{ display: 'inline-flex' }}
  //           >
  //             <input
  //               type="checkbox"
  //               id="patientAuthorization"
  //               name="patientAuthorization"
  //               checked={patientAuthorizationChecked}
  //               onChange={handleCheckboxChange}
  //               style={{
  //                 minWidth: '1.5rem',
  //                 minHeight: '1.5rem',
  //                 borderRadius: theme.effects.roundedCorner6,
  //                 outline: 'none',
  //               }}
  //             />
  //             <Stack horizontalAlign="start" verticalAlign="center">
  //               <label htmlFor="textTerms" style={{ marginLeft: '0.5rem' }}>
  //                 {zoryvePatientAuthorizationCheckbox}
  //               </label>
  //             </Stack>
  //           </Stack>
  //         </div>
  //       </Stack>

  //       <Stack horizontal horizontalAlign="center" style={{ padding: '1rem' }}>
  //         <PrimaryButton
  //           className={mergeStyles({
  //             height: '2.5rem',
  //             minWidth: '8rem',
  //             borderRadius: theme.effects.roundedCorner6,
  //             boxShadow: theme.effects.elevation8,
  //             fontSize: '16px',
  //             color: theme.palette.neutralLight,
  //             background: theme.palette.themePrimary,
  //             ':disabled': {
  //               background: '#faecc0',
  //               color: '#b3b3b3',
  //             },
  //           })}
  //           disabled={isButtonsDisabled}
  //           onClick={() => handleOnSubmit()}
  //         >
  //           Submit
  //         </PrimaryButton>
  //       </Stack>
  //     </div>
  //   </Modal>
  // );
  return (
    <Stack style={{paddingBottom: '1rem'}}>
      <Stack style={{ width: '85%', paddingBottom: '0rem', borderRadius: '10px' }}>
        <Text
          style={{
            cursor: 'pointer',
            background: theme.palette.themePrimary,
            padding: '0.5rem',
            color: 'black',
            textAlign: 'center',
            borderRadius: '10px' 
          }}
          onClick={() => setIsModalOpen(true)}
        >
          <u>ZORYVE DIRECT SAVINGS PROGRAM TERMS</u>
        </Text>
      </Stack>
      <Modal
        isOpen={isModalOpen}
        allowTouchBodyScroll={true}
        isBlocking={false}
        onDismiss={() => setIsModalOpen(false)}
        styles={{
          main: { borderRadius: theme.effects.roundedCorner6, minHeight: 0 },
        }}
      >
        <div
          className={mergeStyles({
            padding: '1rem',
            boxShadow: theme.effects.elevation8,
            width: width,
            borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
            background: theme.palette.neutralPrimary,
          })}
        >
          <Stack
            style={{
              height: '100%',
              color: 'black',
              paddingBottom: '10rem',
            }}
          >
            <span style={{fontSize: '16px', fontWeight: 700}}>SAVING PROGRAM TERMS</span>
            {zoryveSavingsProgramTerms}
          </Stack>
          <PrimaryButton
            className={mergeStyles({
              height: '3rem',
              color: 'black',
              minWidth: '8rem',
              width: '90%',
              borderRadius: theme.effects.roundedCorner6,
              boxShadow: theme.effects.elevation8,
              position: 'absolute',
              bottom: 10,
              left: 'auto',
              right: 'auto',
            })}
            onClick={() => setIsModalOpen(false)}
          >
          Accept
          </PrimaryButton>
        </div>
      </Modal>
    </Stack>

  );
};

export const CopayCardImage = (props: {
  pdfUrl: string;
  qrImageUrl: string;
  pngCard: string;
  bin: string;
  pcn: string;
  grp: string;
  id: string;
}): JSX.Element => {
  return (
    <Stack
      style={{
        position: 'relative',
        width: '320px',
        // border: '0.5px solid black',
        borderRadius: '14px',
        minHeight: '200px',
      }}
    >
      <img src={props.pngCard} style={{ width: '100%' }} />
    </Stack>
  );
};

export const AddToMobileWallet = (): JSX.Element => {
  const [loading, isLoading] = React.useState(true);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [enrollment, setEnrollment] = React.useState<any>();
  const messagesEnd = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    messagesEnd?.current?.scrollIntoView({ behavior: 'smooth' });
  });

  React.useEffect(() => {
    createEnrollment()
      .then((res) => {
        isLoading(false);
        setEnrollment(res.data.enrollment);
        console.log('Enrollment Data', JSON.stringify(res.data));
      })
      .catch((err) => {
        console.log('Error', err);
      });
  }, []);

  if (loading) {
    return (
      <Stack
        horizontalAlign="center"
        verticalAlign="center"
        style={{ height: '100%', width: '100%' }}
      >
        <SpinnerLoader />
      </Stack>
    );
  } else {
    return (
      <>
        <RemoteMessage
          text={
            <Text>
              Thank you! Please see your ZORYVE Direct Savings Card Info below:
              <br />
              <br />
              BIN: {enrollment?.CardResponseInfo?.Bin}
              <br />
              PCN: {enrollment?.CardResponseInfo?.Pcn}
              <br />
              GROUP: {enrollment?.CardResponseInfo?.Group}
              <br />
              ID: {enrollment?.CardResponseInfo?.MemberId}
            </Text>
          }
        />
        <br />
        <CopayCardImage
          pdfUrl={enrollment?.CardResponseInfo.PdfCard}
          qrImageUrl={enrollment?.CardResponseInfo.ImageQr}
          pngCard={enrollment?.CardResponseInfo.PngCard}
          bin={enrollment?.CardResponseInfo.Bin}
          pcn={enrollment?.CardResponseInfo.Pcn}
          grp={enrollment?.CardResponseInfo.Group}
          id={enrollment?.CardResponseInfo.MemberId}
        />
        <br />
        <PrimaryButton
          style={{
            width: '85%',
            borderRadius: '14px',
            height: '42px',
            boxShadow: 'rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
            color: 'black',
          }}
          onClick={() => {
            window.open(enrollment?.CardResponseInfo.WalletCard);
          }}
        >
          Add to Mobile Wallet
        </PrimaryButton>
        <div
          style={{ float: 'left', clear: 'both', paddingBottom: '4rem' }}
          ref={messagesEnd}
        ></div>
      </>
    );
  }
};

export const AddToMobileWalletExisting = (): JSX.Element => {
  const [loading, isLoading] = React.useState(true);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [enrollment, setEnrollment] = React.useState<any>();
  const messagesEnd = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    messagesEnd?.current?.scrollIntoView({ behavior: 'smooth' });
  });

  React.useEffect(() => {
    console.log('Checking existing account');
    checkExistingAccount()
      .then((res) => {
        console.log('Enrollment Data', JSON.stringify(res.data));
        setEnrollment(res.data.enrollment);
        if (res.data.enrollment.CardResponseInfo?.MemberId) {
          isLoading(false);
        }
      })
      .catch((err) => {
        console.log('Error', err);
      });
  }, []);

  if (loading) {
    return (
      <Stack
        horizontalAlign="center"
        verticalAlign="center"
        style={{ height: '100%', width: '100%' }}
      >
        <SpinnerLoader />
      </Stack>
    );
  } else {
    return (
      <>
        <RemoteMessage
          text={
            <Text>
              Thank you! Please see your ZORYVE Direct Savings Card Info below:
              <br />
              <br />
              BIN: {enrollment?.CardResponseInfo?.Bin}
              <br />
              PCN: {enrollment?.CardResponseInfo?.Pcn}
              <br />
              GROUP: {enrollment?.CardResponseInfo?.Group}
              <br />
              ID: {enrollment?.CardResponseInfo?.MemberId}
            </Text>
          }
        />
        <br />
        <CopayCardImage
          pdfUrl={enrollment?.CardResponseInfo.PdfCard}
          qrImageUrl={enrollment?.CardResponseInfo.ImageQr}
          pngCard={enrollment?.CardResponseInfo.PngCard}
          bin={enrollment?.CardResponseInfo.Bin}
          pcn={enrollment?.CardResponseInfo.Pcn}
          grp={enrollment?.CardResponseInfo.Group}
          id={enrollment?.CardResponseInfo.MemberId}
        />
        <br />
        <PrimaryButton
          style={{
            width: '85%',
            borderRadius: '14px',
            height: '42px',
            boxShadow: 'rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
            color: 'black',
          }}
          onClick={() => {
            window.open(enrollment?.CardResponseInfo.WalletCard);
          }}
        >
          Add to Mobile Wallet
        </PrimaryButton>
        <div
          style={{ float: 'left', clear: 'both', paddingBottom: '4rem' }}
          ref={messagesEnd}
        ></div>
      </>
    );
  }
};

export const AddToMobileWalletFromGlobalData = (): JSX.Element => {
  const messagesEnd = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    messagesEnd?.current?.scrollIntoView({ behavior: 'smooth' });
  });

  const bin = GLOBALS.initResponse.metadata.bin;
  const pcn = GLOBALS.initResponse.metadata.pcn;
  const groupId = GLOBALS.initResponse.metadata.groupId;
  const memberId = GLOBALS.initResponse.metadata.memberId;
  const pdfUrl = GLOBALS.initResponse.metadata.pdfUrl;
  const qrImageUrl = GLOBALS.initResponse.metadata.qrImageUrl;
  const walletUrl = GLOBALS.initResponse.metadata.walletUrl;
  const pngCard = GLOBALS.initResponse.metadata.copayCardImageUrl;

  return (
    <>
      <RemoteMessage
        text={
          <Text>
            Thank you! Please see your ZORYVE Direct Savings Card Info below:
            <br />
            <br />
            BIN: {bin}
            <br />
            PCN: {pcn}
            <br />
            GROUP: {groupId}
            <br />
            ID: {memberId}
          </Text>
        }
      />
      <br />
      <CopayCardImage
        pdfUrl={pdfUrl}
        qrImageUrl={qrImageUrl}
        pngCard={pngCard}
        bin={bin}
        pcn={pcn}
        grp={groupId}
        id={memberId}
      />
      <br />
      <PrimaryButton
        style={{
          width: '85%',
          borderRadius: '14px',
          height: '42px',
          boxShadow: 'rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
          color: 'black',
        }}
        onClick={() => {
          window.open(walletUrl);
        }}
      >
        Add to Mobile Wallet
      </PrimaryButton>
      <div style={{ float: 'left', clear: 'both', paddingBottom: '4rem' }} ref={messagesEnd}></div>
    </>
  );
};

export const ZoryvePatientAuthorizationReadOnly = (): JSX.Element => {
  return (
    <Stack style={{ paddingBottom: '0.5rem' }}>
      <RemoteMessage
        text={
          <InlineConsent content={zoryvePatientAuthorization}>
            <>PATIENT AUTHORIZATION</>
          </InlineConsent>
        }
      />
    </Stack>
  );
};

export const zoryvePatientAuthorization = (
  <div style={{ fontSize: '12px' }}>
    By checking the “I certify” box below, I am agreeing that Arcutis Biotherapeutics, Inc. and its
    service providers may use my personal information, including my contact information, information
    related to my medical condition, treatment, and insurance, and the information I supply in
    requesting the ZORYVE Direct Savings Card to administer the Savings Card Program, and to
    evaluate and improve its services and program(s).
    <br />
    <br />
  </div>
);

export const zoryvePatientAuthorizationCheckbox = (
  <div style={{ fontSize: '12px' }}>
    I certify that I am the patient or their legal representative, I am at least 18 years old, and I
    have read and agree to the{' '}
    <a
      style={{ color: 'black' }}
      href="https://www.arcutis.com/privacy/"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Notice
    </a>{' '}
    and the{' '}
    <a
      style={{ color: 'black' }}
      href="https://www.zoryve.com/save-with-zoryve-direct?anchor=terms"
      target="_blank"
      rel="noreferrer"
    >
      Terms and Conditions
    </a>
    .
  </div>
);

export const zoryveSavingsProgramTerms = (
  <div style={{ fontSize: '12px' }}>
    <ul style={{ paddingLeft: '0px', listStyleType: 'none' }}>
      <li>
        <h4 style={{ fontWeight: 700, fontSize: '14px', margin: 0 }}>I. ELIGIBILITY</h4>
        Subject to program limitations and terms and conditions, the ZORYVE® Direct Savings Card
        Program is open to patients who have been prescribed ZORYVE consistent with the{' '}
        <span
          style={{ textDecoration: 'underline' }}
          onClick={() => window.open('https://www.arcutis.com/zoryve-foam-ppi-pt')}
        >
          Prescribing Information
        </span>{' '}
        and ZORYVE consistent with the{' '}
        <span
          style={{ textDecoration: 'underline' }}
          onClick={() => window.open('https://www.arcutis.com/zoryve-ppi-pt')}
        >
          Prescribing Information
        </span>{' '}
        and who have commercial or private insurance. ZORYVE Direct helps eligible patients cover
        out-of-pocket medication costs for ZORYVE, up to program limits.
        <br />
        <br />
        The ZORYVE Direct offer is not valid for patients enrolled in any Government Healthcare
        Program, including Medicare, Medicaid, TRICARE, and any other federal or state healthcare
        program, for cash-paying patients, or where prohibited by law. This offer is only valid in
        the United States and Puerto Rico.
      </li>
      <br />
      <li>
        <h4 style={{ fontWeight: 700, fontSize: '14px', margin: 0 }}>
          II. PROGRAM TERMS AND CONDITIONS ZORYVE
        </h4>
        Direct may modify the savings amount and patient out-of-pocket requirements at any time in
        its sole discretion. If at any time a patient enrolls in a Government Healthcare Program,
        the patient will no longer be able to use this card and must notify ZORYVE Direct
        immediately.
        <br />
        <br />
        Patients must not seek reimbursement for the value received from ZORYVE Direct from any
        third-party payers, including a flexible spending account or healthcare savings account. By
        participating in this program, patients agree to comply with all rules and disclosure
        requirements imposed by their insurance plan and pharmacy benefit manager. Restrictions may
        apply. This offer is subject to change or discontinuation without notice. This is not health
        insurance.
        <br />
        <br />
        Eligible patients may pay as little as $0 or possibly less out-of-pocket for each
        prescription fill, up to a Patient Total Program Savings determined by the program. These
        amounts will vary.
        <br />
        <br />
        The Patient Total Program Savings will not exceed the Maximum Program Limit but may be less
        than the Maximum Program Limit. Patient out-of-pocket cost requirements and Patient Total
        Program Savings will vary depending on the terms of a patient's insurance plan and coverage,
        pharmacy location, and other factors determined solely by Arcutis Biotherapeutics. Each
        patient is responsible for costs above the Patient Total Program Savings amounts.
        <br />
        <br />
        Patients must notify ZORYVE Direct of changes to their insurance. By accepting payments from
        the ZORYVE Direct Savings Card Program made on behalf of participating patients,
        participating PBMs, insurance plans, and pharmacies are responsible for providing ZORYVE
        Direct with accurate information regarding patients and eligibility.
        <br />
        <br />
        Patient Total Program Savings amounts reset each calendar year and re-enrollment in the
        program is required at regular intervals. Patients who have questions should call (844)
        979-1288 from 6:00 am – 5:00 pm PT, Monday – Friday, except holidays.
      </li>
      <br />
      <li>
        <h4 style={{ fontWeight: 700, fontSize: '14px', margin: 0 }}>To the Pharmacist:</h4>
        By accepting the ZORYVE® Direct Savings Card for use, you are subject to its terms and
        conditions, and certify that you:
        <br />
        <ul style={{ paddingLeft: '20px', listStyleType: 'initial' }}>
          <br />
          <li>
            Have not and will not submit a claim for reimbursement for this prescription to any
            Government Healthcare Program;
          </li>
          <br />
          <li>
            Will enter full and accurate patient and insurance information, including relevant payer
            and PBM BIN numbers;
          </li>
          <br />
          <li>Will follow all relevant insurance requirements and payer agreements;</li>
          <br />
          <li>
            Will inform payers about the use of the ZORYVE Direct Savings Card as required by the
            insurance plan, contract, or other relevant law;
          </li>
          <br />
          <li>
            Will not accept and/or utilize cash discount cards or other program information bearing
            a BIN number that could be mistaken for commercial insurance coverage;
          </li>
          <br />
          <li>
            Will follow all ZORYVE Direct Savings Card terms and conditions, which may change
            periodically.
          </li>
          <br />
        </ul>
      </li>
      <br />
      <li>
        To process transactions, follow the steps below:
        <ul style={{ paddingLeft: '20px', listStyleType: 'initial' }}>
          <br />
          <li>
            Input commercial insurance card information as primary coverage. Any remaining patient
            responsibility will be displayed in the transaction response.
          </li>
          <br />
          <li>
            Submit remaining patient responsibility to RIS Rx using BIN# 021940 and transmit using
            the appropriate COB segment of the NCPDP transaction as the secondary coverage.
            Applicable patient savings will be displayed in the transaction response.
          </li>
          <br />
        </ul>
      </li>
      <li>
        For questions regarding setup, claim transmission, patient eligibility, or other issues,
        call (855) 389-9505.
      </li>
      <br />
      <li>
        The ZORYVE Direct Savings Card offer is not valid for patients enrolled in any Government
        Healthcare Program, including Medicare, Medicaid, TRICARE, and any other federal or state
        healthcare program, for cash-paying patients, or where prohibited by law or your agreement
        with patient’s insurance plan or pharmacy benefit manager. This offer is only valid in the
        United States and Puerto Rico.
      </li>
    </ul>
  </div>
);

export const emailConsent = (
  <div>
    By checking the “I agree” box below, I am agreeing that Arcutis Biotherapeutics, Inc. and its
    service providers may use my personal information, including my contact information, information
    related to my medical condition, treatment, and insurance, and the information I supply in
    requesting the ZORYVE Direct Savings Card to reach out to me by email for any of the following
    purposes: conduct adherence programs and provide reminders about my medication, contact me about
    market research, and/or provide me with information (including promotional materials) about its
    products, disease education, or financial assistance. I understand that I may opt out of
    receiving any future promotional emails by (i) emailing privacy@arcutis.com, (ii) clicking on
    the “unsubscribe” link in any promotional emails, or (iii) using the contact information in the{' '}
    <a
      style={{ color: 'black' }}
      href="https://www.arcutis.com/privacy/"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Notice
    </a>{' '}
    .
  </div>
);

export const textConsent = (
  <div>
    By checking the “I agree” box below, I am agreeing that Arcutis Biotherapeutics, Inc. and its
    service providers (collectively, “Arcutis”) may use my personal information including my
    contact information, information related to my medical condition, treatment, and insurance, and
    the information I supply in requesting the ZORYVE Direct Savings Card to reach out to me by
    phone and/or text message (depending on which boxes I check) for any of the following purposes:
    conduct adherence programs and provide reminders about my medication, contact me about market
    research, and/or provide me with information (including promotional materials) about its
    products, disease education, or financial assistance. I understand that Arcutis may use
    automatic dialing machines or artificial or prerecorded messages to call or text me and I agree
    that Arcutis may leave a voicemail for me if I am not available. I understand that I am not
    required to provide this consent as a condition of purchasing any goods or services, and that I
    may opt out of receiving any future promotional calls or text messages by (i) emailing
    privacy@arcutis.com, (ii) using the contact information in the{' '}
    <a
      style={{ color: 'black' }}
      href="https://www.arcutis.com/privacy/"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Notice
    </a>{' '}
    , or (iii) replying STOP to any text message from Arcutis.
  </div>
);

export const ZoryveSavingsCard = (): JSX.Element => {
  const theme = useTheme();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [enrollment, setEnrollment] = React.useState<any>();
  const [loading, isLoading] = React.useState(false);
  useEffect(() => {
    isLoading(true);
    createEnrollment()
      .then((res) => {
        isLoading(false);
        console.log('Enrollment Data', res.data.enrollment);
        setEnrollment(res.data.enrollment);
      })
      .catch((err) => {
        console.log('Error', err);
        isLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <Stack>
        <SpinnerLoader />
      </Stack>
    );
  }

  return enrollment ? (
    <Stack>
      <RemoteMessage
        text={
          <Text>
            Thank you! Please see your ZORYVE Direct Savings Card Info below:
            <br />
            <br />
            BIN: {`${enrollment.bin ?? '021940'}`}
            <br />
            PCN: {`${enrollment.pcn ?? 'PYS'}`}
            <br />
            GROUP: {`${enrollment.groupId ?? '100034'}`}
            <br />
            ID: {`${enrollment.memberId}`}
            <br />
          </Text>
        }
      />
      <Stack
        style={{
          width: '85%',
          marginTop: '1rem',
          maxHeight: '220px',
          marginBottom: '1rem',
        }}
      >
        <img
          src={`${enrollment.ezWalletResponse.copayCardImageUrl}`}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '220px',
          }}
        />
      </Stack>
      <Stack
        style={{
          width: '85%',
          marginBottom: '0.5rem',
        }}
      >
        <PrimaryButton
          style={{
            height: '2.5rem',
            width: '100%',
            borderRadius: theme.effects.roundedCorner6,
            boxShadow: theme.effects.elevation8,
            fontSize: '16px',
            color: theme.palette.neutralLight,
            background: theme.palette.themePrimary,
          }}
          onClick={() => window.open(enrollment.ezWalletResponse.walletPassUrl)}
        >
          Add to Mobile Wallet
        </PrimaryButton>
      </Stack>
    </Stack>
  ) : (
    <></>
  );
};

export const ReminderSavingsCard = (): JSX.Element => {
  const theme = useTheme();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [enrollment, setEnrollment] = React.useState<any>();
  const messagesEnd = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    messagesEnd?.current?.scrollIntoView({ behavior: 'smooth' });
    if (GLOBALS.initResponse.reminderData) {
      setEnrollment(GLOBALS.initResponse.reminderData);
    } else {
      const enrollment: ReminderData = {
        bin: GLOBALS.initResponse.metadata.bin,
        pcn: GLOBALS.initResponse.metadata.pcn,
        groupId: GLOBALS.initResponse.metadata.groupId,
        memberId: GLOBALS.initResponse.metadata.memberId,
        ezWalletResponse: {
          copayCardImageUrl: GLOBALS.initResponse.metadata.copayCardImageUrl,
          walletPassUrl: GLOBALS.initResponse.metadata.walletUrl,
        },
      };
      setEnrollment(enrollment);
    }
  });

  return enrollment ? (
    <Stack>
      <RemoteMessage
        text={
          <Text>
            Thank you! Please see your ZORYVE Direct Savings Card Info below:
            <br />
            <br />
            BIN: {`${enrollment.bin ?? '021940'}`}
            <br />
            PCN: {`${enrollment.pcn ?? 'PYS'}`}
            <br />
            GROUP: {`${enrollment.groupId ?? '100034'}`}
            <br />
            ID: {`${enrollment.memberId}`}
            <br />
          </Text>
        }
      />
      <Stack
        style={{
          width: '85%',
          marginTop: '1rem',
          maxHeight: '220px',
          marginBottom: '1rem',
        }}
      >
        <img
          src={`${enrollment.ezWalletResponse.copayCardImageUrl}`}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '220px',
          }}
        />
      </Stack>
      <Stack
        style={{
          width: '85%',
          marginBottom: '0.5rem',
        }}
      >
        <PrimaryButton
          style={{
            height: '2.5rem',
            width: '100%',
            borderRadius: theme.effects.roundedCorner6,
            boxShadow: theme.effects.elevation8,
            fontSize: '16px',
            color: theme.palette.neutralLight,
            background: theme.palette.themePrimary,
          }}
          onClick={() => window.open(enrollment.ezWalletResponse.walletPassUrl)}
        >
          Add to Mobile Wallet
        </PrimaryButton>
      </Stack>
      <div
        style={{ float: 'left', clear: 'both', paddingBottom: '0.5rem' }}
        ref={messagesEnd}
      ></div>
    </Stack>
  ) : (
    <></>
  );
};

export const NotEligibleInsurance = (): JSX.Element => {
  return (
    <Stack>
      <Stack style={{ marginBottom: '1rem' }}>
        <RemoteMessage
          text={
            <Text>
              Unfortunately, your response indicates that you are not eligible for the ZORYVE Direct
              Savings Card. You may find other assistance by exploring the options below.
            </Text>
          }
        />
      </Stack>

      <Stack style={{ marginBottom: '1rem' }}>
        <RemoteMessage
          text={
            <Text>
              If you don't have insurance or don't have enough insurance, the Arcutis Cares
              <sup>TM</sup> patient assistance program provides Arcutis medication at no cost to
              eligible patients in financial need.* For program and application information, visit{' '}
              <Link
                href="https://www.arcutis.com/arcutiscares/"
                target="_blank"
                rel="noreferrer"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                arcutiscares.com
              </Link>
              .{' '}
            </Text>
          }
        />
      </Stack>

      <Stack style={{ marginBottom: '1rem' }}>
        <RemoteMessage
          text={
            <Text>
              Find out more about{' '}
              <Link
                href="https://www.arcutis.com/arcutiscares/"
                target="_blank"
                rel="noreferrer"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                Arcutis Cares
              </Link>{' '}
              <br />
              <br />
              *Subject to financial eligibility requirements. Other terms and conditions apply.
            </Text>
          }
        />
      </Stack>
    </Stack>
  );
};

export const EmailConsentReadOnly = (): JSX.Element => {
  return (
    <Stack style={{ paddingBottom: '0.5rem' }}>
      <RemoteMessage
        text={
          <InlineConsent content={emailConsent}>
            <>EMAIL ME</>
          </InlineConsent>
        }
      />
    </Stack>
  );
};

export const TextConsentReadOnly = (): JSX.Element => {
  return (
    <Stack style={{ paddingBottom: '0.5rem' }}>
      <RemoteMessage
        text={
          <InlineConsent content={textConsent}>
            <>TEXT ME</>
          </InlineConsent>
        }
      />
    </Stack>
  );
};
